/* eslint-disable */
import masks from "./masks";
import currency from "./currency";
import { getCreditCardType, checkCCValidity } from "./creditCardUtils";

const validation = {
  cpf(strCPF) {
    let Soma;
    let Resto;
    Soma = 0;
    if (
      strCPF === "00000000000" ||
      strCPF === "11111111111" ||
      strCPF === "22222222222" ||
      strCPF === "33333333333" ||
      strCPF === "44444444444" ||
      strCPF === "55555555555" ||
      strCPF === "66666666666" ||
      strCPF === "77777777777" ||
      strCPF === "88888888888" ||
      strCPF === "99999999999"
    ){
      return false;
    }

    for (let i = 1; i <= 9; i++){
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11){
      Resto = 0;
    }
    if (Resto !== parseInt(strCPF.substring(9, 10))){
      return false;
    }

    Soma = 0;
    for (let i = 1; i <= 10; i++){
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11){
      Resto = 0;
    }
    return Resto === parseInt(strCPF.substring(10, 11));
  },
  cnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj === ""){
      return false;
    }

    if (cnpj.length !== 14){
      return false;
    }

    if (
      cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999"
    ){
      return false;
    }

    var tamanho = cnpj.length - 2;
    var numeros = cnpj.substring(0, tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2){
        pos = 9;
      }
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== +digitos.charAt(0)){
      return false;
    }
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2){
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== +digitos.charAt(1)){
      return false;
    }

    return true;
  },

  required(value) {
    if (value.length > 0) {
      return { valid: true };
    } else {
      return { valid: false, msg: "Ops! Este campo é obrigatório preencher" };
    }
  },

  maxPercentageValue(value) {
    return val => {
      if (val <= value) {
        return { valid: true };
      } else {
        return {
          valid: false,
          msg: "A porcentagem não pode ser maior que " + value + "%"
        };
      }
    };
  },

  hasLastName(value) {
    if (value) {
      const parts = value
        .trim()
        .replace(/\s\s+/g, " ")
        .split(" ");

      if (parts.length > 1 && parts[parts.length - 1].length > 1) {
        return {
          valid: true
        };
      } else {
        return {
          valid: false,
          msg: "O sobrenome deve ser informado."
        };
      }
    }
  },

  minLength(length) {
    return value => {
      if (value.length >= length) {
        return { valid: true };
      } else {
        return {
          valid: false,
          msg: "Preencha com no mínimo " + length + " caracteres"
        };
      }
    };
  },

  numbersOnly(value) {
    if (/^[0-9]*$/.test(value)) {
      return { valid: true };
    } else {
      return { valid: false, msg: "Apenas números são permitidos" };
    }
  },

  date(value) {
    if (
      /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(
        masks.date(value)
      )
    ) {
      return { valid: true };
    } else {
      return { valid: false, msg: "Digite uma data de nascimento válida" };
    }
  },

  phone(type) {
    return value => {
      if (value.length > (type === "mobile" ? 10 : 9)) {
        return { valid: true };
      } else {
        if (type === "landline" && value.length === 0) {
          return { valid: true };
        } else {
          return { valid: false, msg: "Digite um telefone válido" };
        }
      }
    };
  },

  ddd(dddOptions) {
    return value => {
      if (value.length === 0) {
        return { valid: true };
      }
      const ddd = value.substr(0, 2);
      if (dddOptions.find(el => el.ddd.slice(-2) === ddd)) {
        return { valid: true };
      } else {
        return { valid: false, msg: "Digite um DDD válido" };
      }
    };
  },

  cep(value) {
    if (value.length === 8) {
      return { valid: true };
    } else {
      return { valid: false, msg: "Informe um CEP válido" };
    }
  },

  vCpf(value) {
    if (validation.cpf(value)) {
      return { valid: true };
    } else {
      return {
        valid: false,
        msg: "Digite um CPF válido"
      };
    }
  },

  lettersOnly(value) {
    if (/^[a-zA-Z\s]+$/.test(value)) {
      return { valid: true };
    } else {
      return {
        valid: false,
        msg: "Caracteres especiais e/ou números não permitidos"
      };
    }
  },

  email(value) {
    if (/(^\w.*@\w+\.\w)/.test(value)) {
      return { valid: true };
    } else {
      return { valid: false, msg: "Digite um email válido" };
    }
  },

  greaterThan(limit) {
    return value => {
      value = value
        .replace("R$", "")
        .split(".")
        .join("")
        .replace(",", ".");
      if (parseFloat(value) > limit) {
        return { valid: true };
      } else {
        return {
          valid: false,
          msg:
            "Digite um valor maior que R$ " + currency.numberToCurrency(limit)
        };
      }
    };
  },

  lessThan(limit) {
    return value => {
      value = value
        .replace("R$", "")
        .split(".")
        .join("")
        .replace(",", ".");
      if (parseFloat(value) < limit) {
        return { valid: true };
      } else {
        return {
          valid: false,
          msg:
            "Digite um valor menor que R$ " + currency.numberToCurrency(limit)
        };
      }
    };
  },

  credicCard(value) {
    const cardType = getCreditCardType(value);
    if (
      !cardType.name ||
      !cardType.digits.some(d => d === value.length) ||
      !checkCCValidity(value)
    ) {
      return {
        valid: false,
        msg: "Cartão de crédito inválido"
      };
    }
    return {
      valid: true
    };
  },

  creditValidity(value) {
    const checkDateFormat = () => {
      if (value.length === 4) {
        const month = parseInt(value.substr(0, 2));
        const year = 2000 + parseInt(value.substr(2, 2));

        if (month === 0 || month > 12) {
          return false;
        }

        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;

        if (currentYear < year) {
          return true;
        } else if (currentYear === year) {
          return currentMonth <= month;
        }
        return false;
      }

      return false;
    };

    if (!checkDateFormat()) {
      return {
        valid: false,
        msg: "Data de validade inválida"
      };
    }
    return {
      valid: true
    };
  }
};

export default validation;
